<template lang="pug">
.container.grid-xl
  .columns.mensagens
    .column.col-auto.mt-2
      h1.h6.m-2
        i.fa.fa-envelope.fa-fw
        |  Caixa de mensagens
      .divider
      div
        router-link.btn.btn-link.menu-link(:to="{name: 'mensagensRecebidas'}")
          i.fa.fa-inbox.fa-fw
          |  Mensagens recebidas
      div
        router-link.btn.btn-link.menu-link(:to="{name: 'mensagensEnviadas'}")
          i.fa.fa-paper-plane.fa-fw
          |  Mensagens enviadas
      .divider
      div
        a.btn.btn-link.menu-link(@click="$refs.form.show()")
          i.fa.fa-plus.fa-fw
          |  Nova mensagem
      div
        router-link.btn.btn-link.menu-link(:to="{name: 'mensagensEnviadas.comunicado.add'}")
          i.fa.fa-bullhorn.fa-fw
          |  Novo comunicado interno
    .column.col-auto.divider-vert
    .column
      form-create(ref="form")
      router-view
</template>

<script>
import FormCreate from './form/Form'

export default {
  components: { FormCreate },
}
</script>

<style lang="stylus">
.mensagens
  .menu-link.router-link-active
    background-color #f1f1f1
  .full-height
    height auto
    padding 50px 0
</style>
